import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const configuratorPageK = {
  groupByDateThisMonth: "configurator_page.groupByDateThisMonth",
  general: "configurator_page.general",
  switchToProductsToViewFilteredResults: "configurator_page.switchToProductsToViewFilteredResults",
  products: "configurator_page.products",
  addProduct: "configurator_page.addProduct",
  getStartedByClickingNewConfiguration: "configurator_page.getStartedByClickingNewConfiguration",
  selectProduct: "configurator_page.selectProduct",
  configurationLabels: "configurator_page.configurationLabels",
  selectSystem: "configurator_page.selectSystem",
  groupByMissingInfo: "configurator_page.groupByMissingInfo",
  noSystemsFound: "configurator_page.noSystemsFound",
  dateTo: "configurator_page.dateTo",
  groupByInvalidInfo: "configurator_page.groupByInvalidInfo",
  configurationName: "configurator_page.configurationName",
  configurations: "configurator_page.configurations",
  areYouSureYouWantToDeleteSelectedProducts: "configurator_page.areYouSureYouWantToDeleteSelectedProducts",
  groupByMissingInfoNo: "configurator_page.groupByMissingInfoNo",
  width: "configurator_page.width",
  deleteConfiguration: "configurator_page.deleteConfiguration",
  other: "configurator_page.other",
  expandAllGroups: "configurator_page.expandAllGroups",
  partsList: "configurator_page.partsList",
  sortByConfigurationName: "configurator_page.sortByConfigurationName",
  groupByDateOlder: "configurator_page.groupByDateOlder",
  addSystem: "configurator_page.addSystem",
  newConfiguration: "configurator_page.newConfiguration",
  sortGroupsBy: "configurator_page.sortGroupsBy",
  sortOrder: "configurator_page.sortOrder",
  groupByProductType: "configurator_page.groupByProductType",
  attributes: "configurator_page.attributes",
  label: "configurator_page.label",
  addLabel: "configurator_page.addLabel",
  sortByProductCount: "configurator_page.sortByProductCount",
  groupByConfigurationName: "configurator_page.groupByConfigurationName",
  height: "configurator_page.height",
  sharedConfiguration: "configurator_page.sharedConfiguration",
  groupByConfigurationLabel: "configurator_page.groupByConfigurationLabel",
  sortByProductName: "configurator_page.sortByProductName",
  systems: "configurator_page.systems",
  productLabels: "configurator_page.productLabels",
  sortByProductType: "configurator_page.sortByProductType",
  productInformation: "configurator_page.productInformation",
  viewSettings: "configurator_page.viewSettings",
  sortGroupsByCount: "configurator_page.sortGroupsByCount",
  sortByCreatedOn: "configurator_page.sortByCreatedOn",
  dateFrom: "configurator_page.dateFrom",
  labels: "configurator_page.labels",
  groupBy: "configurator_page.groupBy",
  clearFilters: "configurator_page.clearFilters",
  sortByProductNumber: "configurator_page.sortByProductNumber",
  sharedAttribute: "configurator_page.sharedAttribute",
  sortByModifiedOn: "configurator_page.sortByModifiedOn",
  groupByDateToday: "configurator_page.groupByDateToday",
  isMissingInformation: "configurator_page.isMissingInformation",
  sortBy: "configurator_page.sortBy",
  groupByDateThisWeek: "configurator_page.groupByDateThisWeek",
  groupByNone: "configurator_page.groupByNone",
  keepTypingToNarrowTheList: "configurator_page.keepTypingToNarrowTheList",
  editProducts: "configurator_page.editProducts",
  noConfigurations: "configurator_page.noConfigurations",
  productType: "configurator_page.productType",
  areYouSureYouWantToDeleteThisProductConfiguration: "configurator_page.areYouSureYouWantToDeleteThisProductConfiguration",
  productIsMissingInformation: "configurator_page.productIsMissingInformation",
  groupByUnlabelled: "configurator_page.groupByUnlabelled",
  sortByNone: "configurator_page.sortByNone",
  configuration: "configurator_page.configuration",
  product: "configurator_page.product",
  groupByProductName: "configurator_page.groupByProductName",
  collapseAllGroups: "configurator_page.collapseAllGroups",
  thisProductTypeHasNoConfigurations: "configurator_page.thisProductTypeHasNoConfigurations",
  notSelected: "configurator_page.notSelected",
  productHasInvalidInformation: "configurator_page.productHasInvalidInformation",
  groupByMissingInfoYes: "configurator_page.groupByMissingInfoYes",
  sortGroupsByAlphabetical: "configurator_page.sortGroupsByAlphabetical",
  system: "configurator_page.system",
  baseSetup: "configurator_page.baseSetup",
  isInvalidInformation: "configurator_page.isInvalidInformation",
  noProductsFound: "configurator_page.noProductsFound",
  noProductSelected: "configurator_page.noProductSelected",
  addDoorFrame: "configurator_page.addDoorFrame",
  editingProductsOfType: "configurator_page.editingProductsOfType",
  productHasMissingOrInvalidInformation: "configurator_page.productHasMissingOrInvalidInformation",
  groupByDate: "configurator_page.groupByDate",
  areYouSureYouWantToDeleteThisWholeConfiguration: "configurator_page.areYouSureYouWantToDeleteThisWholeConfiguration",
  sortOptions: "configurator_page.sortOptions",
  areYouSureYouWantToDeleteSelectedConfiguration: "configurator_page.areYouSureYouWantToDeleteSelectedConfiguration",
  labelsApplyToTopLevelProductsOnly: "configurator_page.labelsApplyToTopLevelProductsOnly",
  groupByLabel: "configurator_page.groupByLabel",
  selectProductAndSave: "configurator_page.selectProductAndSave",
  selected: "configurator_page.selected",
};

export const useConfiguratorPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      groupByDateThisMonth: t(configuratorPageK.groupByDateThisMonth),
      general: t(configuratorPageK.general),
      switchToProductsToViewFilteredResults: t(configuratorPageK.switchToProductsToViewFilteredResults),
      products: t(configuratorPageK.products),
      addProduct: t(configuratorPageK.addProduct),
      getStartedByClickingNewConfiguration: t(configuratorPageK.getStartedByClickingNewConfiguration),
      selectProduct: t(configuratorPageK.selectProduct),
      configurationLabels: t(configuratorPageK.configurationLabels),
      selectSystem: t(configuratorPageK.selectSystem),
      groupByMissingInfo: t(configuratorPageK.groupByMissingInfo),
      noSystemsFound: t(configuratorPageK.noSystemsFound),
      dateTo: t(configuratorPageK.dateTo),
      groupByInvalidInfo: t(configuratorPageK.groupByInvalidInfo),
      configurationName: t(configuratorPageK.configurationName),
      configurations: t(configuratorPageK.configurations),
      areYouSureYouWantToDeleteSelectedProducts: t(configuratorPageK.areYouSureYouWantToDeleteSelectedProducts),
      groupByMissingInfoNo: t(configuratorPageK.groupByMissingInfoNo),
      width: t(configuratorPageK.width),
      deleteConfiguration: t(configuratorPageK.deleteConfiguration),
      other: t(configuratorPageK.other),
      expandAllGroups: t(configuratorPageK.expandAllGroups),
      partsList: t(configuratorPageK.partsList),
      sortByConfigurationName: t(configuratorPageK.sortByConfigurationName),
      groupByDateOlder: t(configuratorPageK.groupByDateOlder),
      addSystem: t(configuratorPageK.addSystem),
      newConfiguration: t(configuratorPageK.newConfiguration),
      sortGroupsBy: t(configuratorPageK.sortGroupsBy),
      sortOrder: t(configuratorPageK.sortOrder),
      groupByProductType: t(configuratorPageK.groupByProductType),
      attributes: t(configuratorPageK.attributes),
      label: t(configuratorPageK.label),
      addLabel: t(configuratorPageK.addLabel),
      sortByProductCount: t(configuratorPageK.sortByProductCount),
      groupByConfigurationName: t(configuratorPageK.groupByConfigurationName),
      height: t(configuratorPageK.height),
      sharedConfiguration: t(configuratorPageK.sharedConfiguration),
      groupByConfigurationLabel: t(configuratorPageK.groupByConfigurationLabel),
      sortByProductName: t(configuratorPageK.sortByProductName),
      systems: t(configuratorPageK.systems),
      productLabels: t(configuratorPageK.productLabels),
      sortByProductType: t(configuratorPageK.sortByProductType),
      productInformation: t(configuratorPageK.productInformation),
      viewSettings: t(configuratorPageK.viewSettings),
      sortGroupsByCount: t(configuratorPageK.sortGroupsByCount),
      sortByCreatedOn: t(configuratorPageK.sortByCreatedOn),
      dateFrom: t(configuratorPageK.dateFrom),
      labels: t(configuratorPageK.labels),
      groupBy: t(configuratorPageK.groupBy),
      clearFilters: t(configuratorPageK.clearFilters),
      sortByProductNumber: t(configuratorPageK.sortByProductNumber),
      sharedAttribute: t(configuratorPageK.sharedAttribute),
      sortByModifiedOn: t(configuratorPageK.sortByModifiedOn),
      groupByDateToday: t(configuratorPageK.groupByDateToday),
      isMissingInformation: t(configuratorPageK.isMissingInformation),
      sortBy: t(configuratorPageK.sortBy),
      groupByDateThisWeek: t(configuratorPageK.groupByDateThisWeek),
      groupByNone: t(configuratorPageK.groupByNone),
      keepTypingToNarrowTheList: t(configuratorPageK.keepTypingToNarrowTheList),
      editProducts: t(configuratorPageK.editProducts),
      noConfigurations: t(configuratorPageK.noConfigurations),
      productType: t(configuratorPageK.productType),
      areYouSureYouWantToDeleteThisProductConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteThisProductConfiguration),
      productIsMissingInformation: t(configuratorPageK.productIsMissingInformation),
      groupByUnlabelled: t(configuratorPageK.groupByUnlabelled),
      sortByNone: t(configuratorPageK.sortByNone),
      configuration: t(configuratorPageK.configuration),
      product: t(configuratorPageK.product),
      groupByProductName: t(configuratorPageK.groupByProductName),
      collapseAllGroups: t(configuratorPageK.collapseAllGroups),
      thisProductTypeHasNoConfigurations: t(configuratorPageK.thisProductTypeHasNoConfigurations),
      notSelected: t(configuratorPageK.notSelected),
      productHasInvalidInformation: t(configuratorPageK.productHasInvalidInformation),
      groupByMissingInfoYes: t(configuratorPageK.groupByMissingInfoYes),
      sortGroupsByAlphabetical: t(configuratorPageK.sortGroupsByAlphabetical),
      system: t(configuratorPageK.system),
      baseSetup: t(configuratorPageK.baseSetup),
      isInvalidInformation: t(configuratorPageK.isInvalidInformation),
      noProductsFound: t(configuratorPageK.noProductsFound),
      noProductSelected: t(configuratorPageK.noProductSelected),
      addDoorFrame: t(configuratorPageK.addDoorFrame),
      editingProductsOfType: (total: string) => t(configuratorPageK.editingProductsOfType, { total }),
      productHasMissingOrInvalidInformation: t(configuratorPageK.productHasMissingOrInvalidInformation),
      groupByDate: t(configuratorPageK.groupByDate),
      areYouSureYouWantToDeleteThisWholeConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteThisWholeConfiguration),
      sortOptions: t(configuratorPageK.sortOptions),
      areYouSureYouWantToDeleteSelectedConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteSelectedConfiguration),
      labelsApplyToTopLevelProductsOnly: (skipped: string, total: string) => t(configuratorPageK.labelsApplyToTopLevelProductsOnly, { skipped, total }),
      groupByLabel: t(configuratorPageK.groupByLabel),
      selectProductAndSave: t(configuratorPageK.selectProductAndSave),
      selected: t(configuratorPageK.selected),
    }),
    [i18n.language]
  );
};